<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "EquipmentRadioButton",
  props: {
    data: {
      type: Object,
    },
  },
  data: function () {
    return {
      equipments: [],
    };
  },
  methods: {
    save: function () {},
  },
};
</script>

<style lang="scss">
.choices-wrapper {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 10px;

  p {
    margin: 0;
    color: #767676;
    font-size: 15px;
  }
}
</style>

<template>
  <div class="choices-wrapper d-flex justify-content-between">
    <p>{{ data.label }}</p>
    <div class="">
      <b-form-radio value="no" v-model="equipments[`e${data.id}`]"
        >No</b-form-radio
      >
      <b-form-radio value="With Optional" v-model="equipments[`e${data.id}`]"
        >With Optional</b-form-radio
      >
      <b-form-radio value="required" v-model="equipments[`e${data.id}`]"
        >Required</b-form-radio
      >
    </div>
  </div>
</template>